import config from '../../config';
export async function s3DownloadURL(key) {
  let headers = new Headers();
  let bearer = 'Bearer ' + config.getTokenLocalStorage();
  headers.append('Authorization', bearer);
  let options = {
    method: 'GET',
    headers: headers
  };
  return fetch(`/nld_tracker/s3/download?key=${key}`, options).then((data) =>
    data.json()
  );
}

export const makePath = (prefix) => {
  const pathParts = [
    <span key={process.env.REACT_APP_S3_BUCKET}>
      <a href={'/bucketview?s3_prefix='}>
        &#128193; {process.env.REACT_APP_S3_BUCKET}
      </a>
    </span>
  ];
  pathParts.push(
    <span key='unique key' style={{ marginLeft: '5px', marginRight: '5px' }}>
      /
    </span>
  );
  const a = prefix.split('/');
  for (var i = 0; i < a.length; i++) {
    const item = a[i];
    if (item.trim().length > 0) {
      const goToPrefix = a.slice(0, i + 1).join('/') + '/';
      pathParts.push(
        <span key={item}>
          <a href={`/bucketview?s3_prefix=${encodeURIComponent(goToPrefix)}`}>
            &#128193; {item}
          </a>
        </span>
      );
      if (i !== a.length - 1) {
        pathParts.push(
          <span key={i} style={{ marginLeft: '5px', marginRight: '5px' }}>
            /
          </span>
        );
      }
    }
  }
  return pathParts;
};
